import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import { hex } from 'utils/hex'

const useStyles = makeStyles(() => ({
  root: (pr) => ({
    backgroundColor: pr.isSelected
      ? hex(pr.hoverColor || '#f0f0f0', 10)
      : pr.isFocusRow
      ? '#EAEBED'
      : '#ffffff',
    '&:hover': {
      backgroundColor: hex(pr.hoverColor || '#f0f0f0', 10),
    },
  }),
}))

const Row = (props) => {
  const {
    children,
    className = '',
    hoverColor,
    isSelected,
    isFocusRow,
    ...rest
  } = props
  const classes = useStyles({ hoverColor, isSelected, isFocusRow })
  return (
    <tr className={clsx('table_row', className, classes.root)} {...rest}>
      {children}
    </tr>
  )
}

export default memo(Row)
